import { render, staticRenderFns } from "./SidebarNavLink.vue?vue&type=template&id=221a9dc0&"
import script from "./SidebarNavLink.vue?vue&type=script&lang=js&"
export * from "./SidebarNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/SidebarNavLink.vue
// module id = null
// module chunks = 